import styled from "styled-components";

export const ChecklistContainer = styled.div`
  background: #ffffff;
  border: 1px solid #E2E6EA;
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05), 0 4px 12px rgba(0, 0, 0, 0.04);
  min-width: 340px;
  max-width: 380px;
  height: fit-content;
  position: sticky;
  top: 20px;
  transition: box-shadow 0.3s ease;

  &:hover {
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.06), 0 8px 16px rgba(0, 0, 0, 0.06);
  }

  @media (max-width: 1024px) {
    position: relative;
    top: 0;
    max-width: 100%;
    min-width: 100%;
  }
`;

export const ChecklistHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 20px;
  padding-bottom: 16px;
  border-bottom: 1px solid #f1f3f4;
`;

export const ChecklistTitle = styled.h3`
  font-size: 15px;
  font-weight: 600;
  color: #1F1F1F;
  margin: 0;
  line-height: 1.4;
`;

export const ProgressInfo = styled.div`
  font-size: 13px;
  color: #5f6368;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 4px;
  font-weight: 500;

  span {
    font-size: 16px;
    font-weight: 700;
    color: #1264C7;
  }
`;

export const ChecklistItems = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const ChecklistItem = styled.div<{ $checked: boolean }>`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  border-radius: 10px;
  transition: all 0.2s ease;
  cursor: default;
  background: ${(props) => (props.$checked ? "#e8f5e9" : "transparent")};
  border: 1px solid ${(props) => (props.$checked ? "#c8e6c9" : "transparent")};

  &:hover {
    background: ${(props) => (props.$checked ? "#e8f5e9" : "#F7F9FC")};
    border-color: ${(props) => (props.$checked ? "#c8e6c9" : "#E2E6EA")};
  }
`;

export const CheckCircle = styled.div<{ $checked: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${(props) => (props.$checked ? "#1E8E3E" : "#E2E6EA")};
  transition: all 0.3s ease;
  flex-shrink: 0;

  svg {
    font-size: 22px;
  }
`;

export const ItemLabel = styled.span<{ $checked: boolean }>`
  font-size: 14px;
  font-weight: ${(props) => (props.$checked ? "600" : "500")};
  color: ${(props) => (props.$checked ? "#1E8E3E" : "#5f6368")};
  text-decoration: ${(props) => (props.$checked ? "line-through" : "none")};
  transition: all 0.2s ease;
  line-height: 1.5;
  flex: 1;
`;
